import React from 'react';
import PropTypes from 'prop-types';

import ClientNameView from './ClientNameView';
import ClientNameEdit from './ClientNameEdit';

const ClientName = (props) => {
  const [isEditing, setIsEditing] = React.useState(false);

  const {
    clientData,
    clientBackend,
  } = props;

  return (
    <>
      <ClientNameView
        clientData={clientData}
        clientBackend={clientBackend}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />
      {
        isEditing &&
        <ClientNameEdit
          clientData={clientData}
          clientBackend={clientBackend}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      }
    </>
  );
};

ClientName.propTypes = {
  clientData: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
};

export default React.memo(ClientName);
